<script setup>
import BaseDropdown from '@/components/BaseDropdown.vue'

import { computed, inject, ref} from 'vue'
const emit = defineEmits(['updateSelectedPayment']);

const selectedPayment = ref(null)
const siteConfig = inject('siteConfig')


const payDroplist = computed(() => {
  return {
    label: 'Select a payment option',
    selectedItem: selectedPayment.value || 'Please select',
    direction: '',
    options: siteConfig.features.payWhatYouCan.options,
  }
})

const updateSelected = ($event) => {
  selectedPayment.value = $event

  console.log('selectedPayment', selectedPayment.value)
  emit('updateSelectedPayment', $event);
}
</script>

<template>
  <div class="input-component">
    <BaseDropdown
      :dropdown="payDroplist"
      class="gray-bg"
      @update-selected="updateSelected"
    />
    <!-- <BaseDropdown
                v-if="userStore.campaigns.length && siteConfig.features.campaigns.enabled"
                :dropdown="campaignsDroplist"
                class="gray-bg mt-4"
                @updateSelected="updateSelectedCampaign"
              /> -->
  </div>
</template>

<style scoped>

</style>